const CACHE_PREFIX = "polaris.instantchat.available:";

function cacheUserKey(): string | null {
    const userId = localStorage.getItem("loggedInUserId") || localStorage.getItem("userId");
    return userId ? `${CACHE_PREFIX}${userId}` : null;
}

export function readCachedTeamChatAccess(): boolean | null {
    try {
        const key = cacheUserKey();
        if (!key) {
            return null;
        }
        const raw = sessionStorage.getItem(key);
        if (raw === "true") {
            return true;
        }
        if (raw === "false") {
            return false;
        }
    } catch {
        // Private mode or blocked storage — treat as unknown.
    }
    return null;
}

export function writeCachedTeamChatAccess(available: boolean): void {
    try {
        const key = cacheUserKey();
        if (!key) {
            return;
        }
        if (available) {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, "false");
        }
    } catch {
        // Ignore storage failures.
    }
}

export function clearTeamChatAccessCache(): void {
    try {
        const key = cacheUserKey();
        if (key) {
            sessionStorage.removeItem(key);
        }
    } catch {
        // Ignore storage failures.
    }
}
